import React, { useEffect } from 'react';
import CustomHandler from '../CustomHandler';
import PolygonEllipse from './PolygonEllipse';
import PropTypes from 'prop-types';
import { DEFAULT_FILL_OPACITY } from '../../../utils/constants/Map';
import isEmpty from 'lodash/isEmpty';

const Ellipse = ({
  map,
  maps,
  ellipse,
  setValues,
  polygonRef,
  infoWindow,
  infoWindowData,
  layers,
  switchedLayer,
  onPolygonClick,
  mapInForm,
  polygonsInForm,
  polylineRef,
  polygonData,
}) => {
  const {
    center,
    radiusX,
    radiusY,
    rotationAngle,
    color,
    editable,
    strokeOpacity,
    strokeWeight,
  } = ellipse;

  const ellipseInstance = new maps.Polygon.Ellipse({
    id: ellipse?.id,
    layer: ellipse?.layer,
    point: new maps.LatLng(center.lat, center.lng),
    r1: radiusY,
    r2: radiusX,
    rotation: rotationAngle,
    strokeColour: color,
    strokeWeight,
    strokeOpacity,
    fillColour: color,
    fillOpacity: DEFAULT_FILL_OPACITY,
    draggable: editable,
    editable: false,
  });

  const ellipsePolylineInstance =
    !polygonsInForm &&
    new maps.Polyline.Ellipse(
      map,
      new maps.LatLng(center.lat, center.lng),
      radiusX,
      radiusY,
      rotationAngle,
      color,
      strokeWeight,
      1,
      ellipse?.id,
      ellipse?.layer,
      // opts,
    );
  ellipsePolylineInstance && ellipsePolylineInstance.setMap(map);
  const updateEllipse = ({ center, distanceX, distanceY, angle }) => {
    ellipseInstance.redrawEllipse(
      center,
      distanceY,
      distanceX,
      distanceY,
      distanceX,
      angle,
    );
  };

  const updateValues = ({ overlay, radiusX, radiusY }) => {
    const values = [
      {
        ...overlay,
        center: {
          ...overlay.center,
          ...ellipseInstance.getCenter().toJSON(),
        },
        radiusX,
        radiusY,
        rotationAngle: overlay.rotationAngle,
      },
    ];
    setValues(values);
  };

  let customHandlers = null;

  if (editable) {
    customHandlers = new maps.CustomHandler();
    customHandlers.positions = customHandlers.create({
      point: ellipseInstance.getCenter(),
      map: map,
      draggable: editable,
      radiusX,
      radiusY,
      angle: rotationAngle,
    });
  }

  useEffect(() => {
    if (ellipsePolylineInstance && polylineRef?.current?.[polygonData.layer]) {
      polylineRef.current[polygonData.layer].push(ellipsePolylineInstance);
    }

    if (polylineRef?.current && ellipsePolylineInstance) {
      Object.assign(polylineRef.current, {
        [polygonData.layer]: [],
      });
      polylineRef.current[polygonData.layer].push(ellipsePolylineInstance);
    }

    return () => {
      ellipsePolylineInstance && ellipsePolylineInstance.setMap(null);
    };
  }, [ellipsePolylineInstance]);
  /* eslint-disable consistent-return */
  useEffect(() => {
    if (!polylineRef?.current) {
      return undefined;
    }
    if (
      !isEmpty(polylineRef.current) &&
      Object.keys(layers).some(k => !layers[k])
    ) {
      switchedLayer.forEach(f => {
        if (!polylineRef.current[f]) {
          polylineRef.current[f] = [];
        }
        const copy = [...polylineRef.current[f]];
        copy.forEach((poly, i) => {
          if (f === poly.layer) {
            poly.setVisible(false);
            polylineRef.current[f].splice(i, 1);
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layers, map, polylineRef]);
  return (
    <>
      <PolygonEllipse
        ellipse={ellipse}
        map={map}
        maps={maps}
        setValues={setValues}
        handlerInstance={customHandlers}
        ellipseInstance={ellipseInstance}
        polygonRef={polygonRef}
        infoWindow={infoWindow}
        infoWindowData={infoWindowData}
        layers={layers}
        switchedLayer={switchedLayer}
        onPolygonClick={onPolygonClick}
        polygonData={ellipse}
        paths={ellipseInstance?.getPath()}
        mapInForm={mapInForm}
      />
      {ellipseInstance && editable && (
        <CustomHandler
          maps={maps}
          map={map}
          setValues={updateValues}
          overlayInstance={ellipseInstance}
          overlay={ellipse}
          updateOverlay={updateEllipse}
          handlerInstance={customHandlers}
        />
      )}
    </>
  );
};

Ellipse.propTypes = {
  map: PropTypes.object,
  maps: PropTypes.object,
  ellipse: PropTypes.object,
  setValues: PropTypes.func,
  onPolygonClick: PropTypes.func,
  infoWindow: PropTypes.object,
  infoWindowData: PropTypes.object,
  polygonRef: PropTypes.object,
  layers: PropTypes.object,
  switchedLayer: PropTypes.array,
  mapInForm: PropTypes.bool,
  polygonsInForm: PropTypes.bool,
  polylineRef: PropTypes.object,
  polygonData: PropTypes.object,
};

export default Ellipse;
